import React, { useEffect } from 'react'
import { Typography, useMediaQuery } from '@material-ui/core'
import CardTable from 'components/CardTable/CardTable';
import { useDispatch, useSelector } from 'react-redux';
import { convertToMapById } from 'helpers/convertToMap';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import { setTagsStation } from 'redux/actions/unitsSection/unitsAction';
import { columnsTags } from './columnsTags';
import RegularButton from 'components/CustomButtons/Button';
import SaveIcon from '@material-ui/icons/Save';
import { sendConfigUnitV2 } from 'redux/actions/unitsSection/unitsAction';

export const AddUnitTags = (props) => {
  const isSmallScreen = useMediaQuery('(max-width: 600px)')
  const { data, onClose } = props
  const dispatch = useDispatch()
  const { token } = useSelector(({ login }) => login)
  const tags = useSelector(state => convertToMapById(state.tagsReducer.tags).filter(tag => tag.idStation === state.unitsReducer.station.id));
  const { tagsStation } = useSelector(({ unitsReducer }) => unitsReducer)

  const handleSendUnitTags = () => {
    const form = {
      id: data.id,
      tags: tagsStation.filter(tg => tg.select).map(tg => tg.id)
    }
    dispatch(sendConfigUnitV2(data.id, form))
    onClose()
  }

  useEffect(() => {
    dispatch(setTagsStation(tags))
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    data?.tags
      ? dispatch(setTagsStation(tags.map(tg => {
        return {
          ...tg,
          select: data?.tags.includes(tg.id)
        }
      }).sort((a, b) => {
        if (a.select === b.select) {
          return 0;
        } else if (a.select) {
          return -1;
        } else {
          return 1;
        }
      })))

      : dispatch(setTagsStation(tags))
      // eslint-disable-next-line
  }, [])
  
  return (
    <CardTable
      hasHeader
      title='Asignar etiquedas a unidad'
      title2={<Typography component="span" color="primary">{data.number}</Typography>}
      icon={<LocalShippingIcon />}
      columns={columnsTags}
      data={tagsStation}
      pageSize={isSmallScreen ? 5 : 10}
      blockBtn
      hasControl
      controls={
        <RegularButton round justIcon color="info" onClick={handleSendUnitTags}>
          <SaveIcon style={{ margin: 0 }} />
        </RegularButton>
      }
    />
  )
}
